import type { MessageCls } from '@setplex/mqbw'
import type { Event, EventCallable } from 'effector'

import { createEffect, createEvent, sample, scopeBind } from 'effector'
import { mq } from './bus'
import { logger } from './lib'

// setup global message queue
export const setup = createEvent()

// map of listeners for different topics, to avoid duplicating creation
const listeners = new Map<string | MessageCls, EventCallable<unknown>>()

export function on<MsgCls extends MessageCls>(constructor: MsgCls): Event<InstanceType<MsgCls>> // prettier-ignore
export function on<T>(path: string): Event<T>
export function on(message: string | MessageCls) {
  let event = listeners.get(message)
  if (event) return event

  event = createEvent<unknown>()

  const subscribeFx = createEffect(() => {
    const handler = scopeBind(event, { safe: true })
    return mq.on(message as string, handler)
  })

  // TODO: this will not work if `on` is called after `setup`, need to rethink this later
  sample({
    clock: setup,
    target: subscribeFx,
  })

  return event
}

// emit event to the message bus
export const emit = createEvent<{ topic: string; payload: unknown } | object>()

const emitFx = createEffect(
  (message: { topic: string; payload: unknown } | object) => {
    const Cls = message.constructor
    if ('topic' in Cls && typeof Cls.topic === 'string') {
      mq.emit(message)
    } else if ('topic' in message && typeof message.topic === 'string') {
      mq.emit(message.topic, message.payload)
    } else {
      logger.error('failed to emit message:', message)
    }
  }
)

sample({
  clock: emit,
  target: emitFx,
})
